export const STEP_PATHS = {
  uetTag: { id: 'uet-tag' },
  tagSetup: {
    id: 'setupTag',
    noTag: {
      id: 'setupTag.noTag',
      selectTagMethod: { id: 'setupTag.noTag.selectTagMethod' },
      installTag: { id: 'setupTag.noTag.installTag' },
      emailTag: { id: 'setupTag.noTag.emailTag' },
      platformTag: { id: 'setupTag.noTag.platformTag' },
      gtmTag: { id: 'setupTag.noTag.gtmTag' },
      platformTagInstructions: { id: 'setupTag.noTag.platformTagInstructions' },
    },
    addEventTag: { id: 'setupTag.addEventTag' },
  },
  endFlow: {
    id: 'endFlow',
  },
};
